export function VerifyEmailNoticePage() {
  return (
    <div className="container py-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <h1 className="h4">Verify your email</h1>
          <p className="text-muted mb-0">
            This will mirror `accounts/templates/accounts/verify_notice.html`.
          </p>
        </div>
      </div>
    </div>
  );
}

